const DADATA_URL = "/ajax/dadata-proxy";

function debounce(fn, t = 300) {
    let timer;
    return function (...rest) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, rest), t);
    };
}

document.addEventListener("DOMContentLoaded", () => {
    const $containerDadata = document.getElementById("dadata");
    const $address = $containerDadata.querySelector(".dadata__field");
    const $region = $containerDadata.querySelector(".dadata__field--region");

    const fetchSuggestions = async (query) => {
        try {
            const response = await fetch(DADATA_URL, {
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({
                    query,
                    count: 10,
                }),
            });

            const result = await response.json();

            return result.suggestions || [];
        } catch (err) {
            console.error("Error get address", err);
            return [];
        }
    };

    const templateItem = (address, index) => {
        return `
           <div class="dadata__item" data-fias-level="${address.data.fias_level ?? ""}" data-item-value="${address["unrestricted_value"]}" data-index="${index}">
				<span class="dadata__item-info">${address["unrestricted_value"]}</span>
			</div>
        `;
    };

    const removeSuggestions = () => {
        const oldContainer =
            $containerDadata.querySelector(".dadata__container");
        if (oldContainer) oldContainer.remove();
    };

    const renderSuggestions = (data) => {
        removeSuggestions();

        const container = document.createElement("div");
        container.classList.add("dadata__container");
        container.style.display = "grid";

        data.forEach((element, index) => {
            const node = templateItem(element, index);

            container.insertAdjacentHTML("beforeend", node);
        });

        container.addEventListener("click", (e) => {
            const item = e.target.closest(".dadata__item");
            if (!item) return;

            const value = item.dataset.itemValue;
            const index = item.dataset.index;
            const selectedData = data[index];

            $address.value = value;
            $region.value = selectedData.data.region;

            removeSuggestions();
        });

        $containerDadata.append(container);
    };

    const handleInput = async () => {
        const query = $address.value.trim();

        // Запрещаем только если совсем пусто
        if (!query) {
            removeSuggestions();
            return;
        }

        const suggestions = await fetchSuggestions(query);
        renderSuggestions(suggestions);
    };

    const debounceInput = debounce(handleInput, 500);

    if ($address) {
        $address.addEventListener("input", debounceInput);
    }

    document.addEventListener('click', (e) => {
        if (!e.target.closest('#dadata')) {
            removeSuggestions();
        }
    });
});
